import './styles/main.scss';

import Layout from './components/templates/layout'

function App() {
  return (
    <Layout />
  );
}

export default App;
